import Vue from 'vue';
import Vuex from 'vuex';
import { IAppState } from './modules/app';
import { IRegisterState } from './modules/register';

Vue.use(Vuex);

export interface IRootState {
  app: IAppState;
  register: IRegisterState;
}

export default new Vuex.Store<IRootState>({});
